
<template>
    <Modal :value="true" footer-hide :width="modalWidth" :closable="false" @on-visible-change="handleVisibleChanged" class-name="vertical-center-modal">
        <div class="image-preview">
            <img :src="image" v-if="image" v-show="loaded" @load="handleImageLoaded">
            <div class="image-loading" v-if="!loaded&&image">
                <Spin size="large" fix></Spin>
            </div>
            <video :src="video" controls v-if="video"></video>
            <Button v-if="0<currentIndex" class="arrow left" shape="circle" icon="ios-arrow-back"
                @click="handleShowPrevious"></Button>
            <Button v-if="mediaList.length-1>currentIndex" class="arrow right" shape="circle" icon="ios-arrow-forward"
                @click="handleShowNext"></Button>
        </div>
    </Modal>
</template>

<script>

import util from "../../utils/util";

export default {
    data() {
        return {
            mediaList: [],
            currentIndex: 0,
            type: 'image',
            image: '',
            video: '',
            loaded: false,
            showError: false,
            modalWidth: util.isMobile() ? 80 : 800
        };
    },
    computed: {
    },
    mounted() {
        let self = this;
        self.init();
    },
    methods: {
        init() {
            let self = this;
            self._refresh();
        },
        handleVisibleChanged(visible) {
            let self = this;
            if (!visible) {
                self._close();
            }
        },
        handleShowPrevious() {
            let self = this;
            self.currentIndex -= 1;
            self._refresh();
        },
        handleShowNext() {
            let self = this;
            self.currentIndex += 1;
            self._refresh();
        },
        handleImageLoaded() {
            let self = this;
            self.loaded = true;
        },
        _close() {
            let self = this;
            setTimeout(() => {
                self.$destroy();
                self.$el.parentNode.removeChild(self.$el);
            }, 500);
        },
        _refresh() {
            let self = this;
            if ('image' == self.type) {
                self.image = self.mediaList[self.currentIndex];
                
            } else if ('video' == self.type) {
                self.video = self.mediaList[self.currentIndex];
            }
        }
    }
};
</script>

<style lang="less">
.vertical-center-modal{
    display: flex;
    align-items: center;
    justify-content: center;

    .ivu-modal{
        top: 0;
    }
}

.image-preview {
    position: relative;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
        max-width: 100%;
        max-height: 90vh;
    }
    video {
        max-width: 100%;
        max-height: 70vh;
    }
    .image-loading {
        position: relative;
        width: 100%;
        padding-bottom: 60%;
        height: 0;
    }
    .error-notice {
        position: absolute;
        top: 10px;
        left: 0;
        width: 100%;
        text-align: center;
        padding: 0 10px;
    }
    .arrow {
        position: absolute;
        display: none;
        &.left {
            left: 0.1rem;
        }
        &.right {
            right: 0.1rem;
        }
    }
    &:hover {
        .arrow {
            display: block;
        }
    }
}
</style>

